import React from 'react';
import Reveal from './Reveal';

export default function AboutSection({ content = {} }) {
  const headline = content?.about_headline || 'ÜBER UNS';

  const intro = content?.about_text ||
    'Someones Direction wurde 2016 in Wien gegründet und ist heute weltweit tätig. Seither erzählen wir Geschichten mit Film und Fotografie. Als eingespieltes Team bringen wir umfassende Erfahrung aus den Bereichen Fashion, Dokumentation, Sport und Hospitality sowie aus Projekten für öffentliche Auftraggeber mit.';
  const highlight = content?.about_highlight || 'Wir widmen jedem Projekt unsere volle Aufmerksamkeit';
  const highlightRest = content?.about_highlight_rest || 'vom ersten Briefing bis zum finalen Frame.';
  const closing = content?.about_closing ||
    'Bei uns gibt es keine unnötigen Agenturstrukturen, keine Übergabe an Juniors und keine Kompromisse bei der Qualität.';

  const stats = [
    { number: content?.stat_1_number || '10+', label: content?.stat_1_label || 'Jahre Erfahrung' },
    { number: content?.stat_2_number || '2000+', label: content?.stat_2_label || 'Realisierte Projekte' },
    { number: content?.stat_3_number || '25+', label: content?.stat_3_label || 'Länder, in denen wir tätig waren' },
  ];

  // Ersten Markennamen im Intro gelb hervorheben
  const brand = 'Someones Direction';
  const introParts = intro.startsWith(brand)
    ? [brand, intro.slice(brand.length)]
    : [null, intro];

  return (
    <section className="section-padding bg-ink text-white relative overflow-hidden" id="about">
      <img
        src="/logo-mark-white.png"
        alt=""
        aria-hidden="true"
        className="absolute -right-24 -bottom-24 w-[420px] opacity-[0.05] pointer-events-none select-none"
      />

      <div className="container-custom relative">
        <Reveal>
          <h2 className="font-display text-5xl md:text-7xl text-yellow mb-10">
            {headline}
          </h2>
        </Reveal>

        {/* Einleitung */}
        <div className="max-w-4xl space-y-6 text-lg md:text-xl leading-relaxed">
          <Reveal delay={0.1}>
            <p className="text-white">
              {introParts[0] && <span className="text-yellow font-semibold">{introParts[0]}</span>}
              {introParts[1]}
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="text-white">
              <span className="text-yellow font-semibold">{highlight}</span>{' '}
              {highlightRest}
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="text-white">{closing}</p>
          </Reveal>
        </div>

        {/* EST. + Signatur */}
        <div className="flex flex-wrap items-end gap-10 mt-14 pt-12 border-t border-white/15">
          <Reveal>
            <div>
              <p className="font-display text-2xl text-white mb-2">EST. 2016</p>
              <p className="text-white/50 text-sm">Wien · weltweit tätig</p>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <img
              src="/signature.png"
              alt="Signatur von Sherif Mobarak"
              className="h-16 w-auto invert opacity-90"
            />
          </Reveal>
        </div>

        {/* Zahlen */}
        <div className="mt-16 pt-12 border-t border-white/15 space-y-6">
          {stats.map((stat, index) => (
            <Reveal key={stat.label} delay={index * 0.1}>
              <div className="flex items-center justify-between gap-8 border-b border-white/10 pb-6 last:border-b-0">
                <span className="font-body font-semibold text-white text-sm md:text-lg uppercase tracking-[0.12em] max-w-xs">
                  {stat.label}
                </span>
                <span className="font-display text-5xl md:text-7xl text-signal leading-none">
                  {stat.number}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
